module.exports = (s) => {
  return [
    {
      name: '广告主账户',
      value: 'advertiser_id',
    },
    {
      name: '投放内容',
      format: (row) => {
        const h = s.$createElement;
        const ele = h(
          'el-select',
          {
            props: {
              size: 'mini',
              value: row.type.value,
              placeholder: '请选择',
            },
            on: {
              change: (type) => {
                row.type.value = type;
                s?.getTargetConfig(type, row);
              },
            },
          },
          row.type.options.map(({ label, value }) => {
            return h('el-option', { props: { label, value }}, null);
          })
        );

        return ele;
      },
    },
    {
      name: '投放内容目标',
      width: '300px',
      format: (row) => {
        const h = s.$createElement;
        const { add_config } = row;
        const type = row.type.value;

        if (type) {
          // 投放内容选择
          const selection_ele = h(
            'el-select',
            {
              class: 'mr-10',
              props: {
                size: 'mini',
                value: row.target[type].value,
                placeholder: '请选择',
              },
              on: {
                change: (value) => {
                  row.target[type].value = value;
                },
              },
            },
            row.target[type].options.map(({ label, value }) => {
              return h('el-option', { props: { label, value }}, null);
            }),
          );

          // 新建 - 投放内容ID
          const add_id_ele = h(
            'el-input',
            {
              class: 'mr-10',
              props: {
                value: add_config.value,
              },
              attrs: {
                placeholder: s.inputIdPlaceholder(type),
              },
              on: {
                input: (value) => {
                  add_config.value = value;
                },
              },
            },
            null,
          );

          // 新建 - 投放内容名称
          const add_name_ele = h(
            'el-input',
            {
              class: 'mt-10',
              props: {
                value: add_config.name,
              },
              attrs: {
                placeholder: s.inputNamePlaceholder(type),
              },
              on: {
                input: (value) => {
                  add_config.name = value;
                },
              },
            },
            null,
          );

          // 新建 - 投放内容提交按钮
          const add_submit_ele = h(
            'el-button',
            {
              props: {
                size: 'mini',
                type: 'primary',
                loading: add_config.is_loading,
              },
              on: {
                click: () => {
                  s.onAdd(row);
                },
              },
            },
            '提交'
          );

          // 新建 - 投放内容取消按钮
          const add_cancel_ele = h(
            'el-button',
            {
              props: {
                size: 'mini',
                type: 'primary',
                plain: true,
              },
              on: {
                click: () => {
                  add_config.is_add = false;
                },
              },
            },
            '取消'
          );

          // 新建投放内容按钮
          const add_btn_ele = h(
            'el-button',
            {
              props: {
                size: 'mini',
                type: 'primary',
              },
              on: {
                click: () => {
                  add_config.value = '';
                  add_config.is_add = true;
                },
              },
            },
            '新建'
          );

          // 同步投放内容按钮
          const pull_btn_ele = h(
            'el-button',
            {
              props: {
                size: 'mini',
                type: 'success',
              },
              on: {
                click: () => {
                  s.onPull(row);
                },
              },
            },
            '同步'
          );

          return h('div', { class: 'flex align-center' }, [
            // 投放内容选择模块
            ...(!add_config.is_add ? [
              selection_ele,
              ...(s.isSupportAdd() ? [add_btn_ele] : []),
              ...(s.isSupportPull() ? [pull_btn_ele] : []),
            ] : []),
            // 新建投放内容模块
            ...(add_config.is_add ? [
              h('div', { class: 'flex-col mr-10' }, [
                add_id_ele,
                ...(s.isSupportAddName() ? [add_name_ele] : []),
              ], null),
              h('div', {}, [add_submit_ele, add_cancel_ele]),
            ] : []),
          ]);
        } else {
          return '-';
        }
      },
    },
  ];
};
